import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import DateTime from '_class/DateTime';
import User from '_class/User';
import { updateStudentAdditionalAdjustmentComment, deleteStudentAdditionalAdjustmentComment } from 'actions/additional_adjustments';
import { Flex, Button, Icon, translate } from '@haldor/ui';
import { Spinner, Collapsible } from 'UI';

var Comments = /*#__PURE__*/function (_Component) {
  _inherits(Comments, _Component);

  var _super = _createSuper(Comments);

  function Comments(props) {
    var _this;

    _classCallCheck(this, Comments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve, reject) {
        values.origin = 'USER';

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            _this.props.reset();

            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "restoreDeletedComment", function (comment) {
      var values = _objectSpread({}, comment);

      values.status = '';

      _this.props.updateStudentAdditionalAdjustmentComment(values);
    });

    _defineProperty(_assertThisInitialized(_this), "deleteComment", function (comment) {
      _this.props.deleteStudentAdditionalAdjustmentComment(comment);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();

        _this.props.submit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderUpdate", function (comment, index) {
      var user = new User(_this.props.user);
      var deleteAllowed = user.isTeacher() || user.isMentor() || user.isPedagogue();
      return /*#__PURE__*/React.createElement("div", {
        className: "comment",
        key: comment.id + '-' + index
      }, /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, comment.createdBy.firstName, " ", comment.createdBy.lastName, ' • ' + comment.text, ' • ' + new DateTime(comment.created).getShortDate(true), comment.creator == _this.props.user.id && _this.props.onSubmit != null || deleteAllowed ? /*#__PURE__*/React.createElement("span", {
        className: "delete--trigger",
        onClick: function onClick() {
          _this.deleteComment(comment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null, comment.creator == _this.props.user.id && _this.props.onSubmit != null && comment.status == "DELETED" || comment.status == "DELETED" && user.isPedagogue() ? /*#__PURE__*/React.createElement("span", {
        className: "delete--trigger",
        onClick: function onClick() {
          _this.restoreDeletedComment(comment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Undo"
      })) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderComment", function (comment, index) {
      var user = new User(_this.props.user);
      var deleteAllowed = user.isTeacher() || user.isMentor() || user.isPedagogue();
      return /*#__PURE__*/React.createElement("div", {
        className: "comment",
        key: comment.id + '-' + index
      }, comment.text, /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, comment.createdBy.firstName, " ", comment.createdBy.lastName, ' • ' + new DateTime(comment.created).getShortDate(true), comment.creator == _this.props.user.id && _this.props.onSubmit != null || deleteAllowed ? /*#__PURE__*/React.createElement("span", {
        className: "delete--trigger",
        onClick: function onClick() {
          _this.deleteComment(comment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null, comment.creator == _this.props.user.id && _this.props.onSubmit != null && comment.status == "DELETED" || comment.status == "DELETED" && user.isPedagogue() ? /*#__PURE__*/React.createElement("span", {
        className: "delete--trigger",
        onClick: function onClick() {
          _this.restoreDeletedComment(comment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Undo"
      })) : null));
    });

    _this.state = {};
    return _this;
  }

  _createClass(Comments, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adjustment = _this$props.adjustment,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting;
      var user = new User(this.props.user);
      var comments = [];
      var allComments = [];
      var deleted = [];

      if (adjustment.comments.length > 0) {
        comments = _toConsumableArray(adjustment.comments);
        comments.sort(function (a, b) {
          return b.id > a.id ? 1 : -1;
        });

        if (user.isPedagogue()) {
          deleted = _toConsumableArray(comments).filter(function (comment) {
            return comment.status == 'DELETED';
          });
        }

        comments = _toConsumableArray(comments).filter(function (comment) {
          return comment.status != 'DELETED';
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "comment-form"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Comments'),
        open: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '1.65rem'
        }
      }, this.props.onSubmit != null ? /*#__PURE__*/React.createElement(Form, {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(Field, {
        component: "textarea",
        type: "text",
        name: "text",
        placeholder: this.props.translate('Write comment'),
        rows: 1,
        onKeyDown: this.onKeyDown,
        disabled: this.props.disabled,
        validate: this.required
      })), /*#__PURE__*/React.createElement(Button, {
        disabled: !this.props.valid
      }, this.props.translate('save'), submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null))) : null, /*#__PURE__*/React.createElement("div", {
        className: "comments"
      }, comments.map(function (comment, index) {
        if (comment.origin == 'USER') {
          return _this2.renderComment(comment, index);
        }
      }), deleted != null && deleted.length > 0 && !this.props.hideDeleted ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Deleted comments')
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '1.65rem'
        }
      }, deleted.map(function (comment, index) {
        if (comment.origin == 'USER') {
          return _this2.renderComment(comment, index);
        }
      }))) : null))), /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('History')
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '1.65rem'
        },
        className: "comments"
      }, comments.map(function (comment, index) {
        if (comment.origin == 'SYSTEM') {
          return _this2.renderUpdate(comment, index);
        }
      }), deleted != null && deleted.length > 0 && !this.props.hideDeleted ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Deleted history')
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '1.65rem'
        }
      }, deleted.map(function (comment, index) {
        if (comment.origin == 'SYSTEM') {
          return _this2.renderUpdate(comment, index);
        }
      }))) : null)));
    }
  }]);

  return Comments;
}(Component);

_defineProperty(Comments, "defaultProps", {
  hideDeleted: false
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  deleteStudentAdditionalAdjustmentComment: deleteStudentAdditionalAdjustmentComment,
  updateStudentAdditionalAdjustmentComment: updateStudentAdditionalAdjustmentComment
})(reduxForm({
  destroyOnUnmount: true
})(Comments));